import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Textarea from 'react-textarea-autosize';

export default class PanelTextarea extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    onInput: PropTypes.func,
    className: PropTypes.string,
    value: PropTypes.string,
    maxCharacters: PropTypes.number // OPTIONAL
  };

  constructor(props) {
    super(props);
    this.state = {
      nCharacters: props.value ? props.value.length : 0
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ nCharacters: this.props.value ? this.props.value.length : 0 });
    }
  }

  handleInput = e => {
    const inputValue = e.target.value;
    if (this.props.maxCharacters && inputValue.length > this.props.maxCharacters) {
      e.target.value = inputValue.slice(0, this.props.maxCharacters);
    } else {
      this.setState({ nCharacters: inputValue.length });
      if (this.props.onInput) {
        this.props.onInput(e);
      }
    }
  };

  render() {
    const { label, disabled, placeholder, value, className, maxCharacters } = this.props;
    const { nCharacters } = this.state;

    const style = className ? className : 'description-input';
    return (
      <Fragment>
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
          <span className="section-title-label">{label && label + ' '}</span>
          <span className="max-characters-blur">{maxCharacters ? `${nCharacters}/${maxCharacters}` : ''}</span>
        </div>
        <div id="description-input-wrapper" className="description-input-wrapper">
          <Textarea
            disabled={disabled}
            placeholder={placeholder}
            className={style}
            value={value}
            onInput={this.handleInput}
          ></Textarea>
        </div>
      </Fragment>
    );
  }
}
